import React from 'react'
import styled from 'react-emotion'

import logo from '../../assets/images/logo.svg'
import colors from '../../utils/colors'
import { Flex, Img } from '../Layout/index'

const Footer = () => {
  return (
    <a href="#">
      <Flex bg={colors.accent} p="5rem">
        <Img m="auto" src={logo} width={[1, 3 / 4, 3 / 4]} maxWidth="800px" />
      </Flex>
    </a>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js